module.exports = __webpack_public_path__ + "static/media/Partner_Workspace_School_and_Network_Import_Template.0fce809d.xlsx";